import userFriendlyEr from '@/utils/userFriendlyEr'
import url from '@/utils/url'
import router from '@/routes'
import { ICON_TYPE_ROUTE_NAME_MAP } from '@/config/map'
import { getGarbageIcon, getMSNIcon } from '@/utils/map/icon'

export default {
  data() {
    return {
      markerPopup: {},
      head: null,
      rows: {},
      fields: {},
      loading: true,
      error: null,
      showMore: false,
    }
  },
  created() {
    this.showMore = !this.$sharedServices.store.getters.isGuest
  },
  destroyed() {
    if (this.destroySubs) {
      this.destroySubs.unsubscribe()
    }
  },
  computed: {
    iconTypeRouteNameMap() {
      return ICON_TYPE_ROUTE_NAME_MAP
    },
  },
  methods: {
    more() {
      let type = this?.subLayerConfig?.iconType || this?.markerModel?.type
      if (!type) {
        if (this.head === 'Отходообразователи') {
          this.fields.garbage_source_type_id
          type = getGarbageIcon(this.fields.garbage_source_type_id)
        }
        if (this.head === 'Места сбора и накопления') {
          this.fields.garbage_source_type_id
          type = getMSNIcon(this.fields.msn_by_type_id)
        }
      }
      const name =
        (this?.subLayerConfig?.routeName &&
          this?.subLayerConfig?.routeName(this.fields)) ||
        this.iconTypeRouteNameMap[type]
      if (!name) {
        console.error(
          `Не найден роут для типа ${type}. Проверьте iconTypeRouteNameMap и/или добавьте туда этот тип`
        )
        return
      }

      const prevRoute = url.getRoute(router.history.current, true)
      router.push({
        name,
        params: { id: this?.id || this?.fields?.id },
        query: { prevRoute },
      })
    },
    registerVueInMap() {
      this.destroySubs = this.$emitter.listen('geo.destroyMap', () => {
        this.$destroy()
      })
    },
    async fetchGeoObjectPopupData(endpoint) {
      this.loading = true
      this.error = null
      try {
        const response = await this.$sharedServices.store.dispatch(
          'updateUrlEndpoint',
          {
            endpoint: endpoint,
            params: {
              disableGlobalError: true,
            },
          }
        )
        this.rows = Object.assign({}, response.data.fields)
        this.head = response.data.head
        this.fields = response.data.model
        if (response.data.model.fkko) {
          this.setFkkoRows(response.data.model.fkko)
        }
      } catch (e) {
        this.error = userFriendlyEr.recognize(e)
      } finally {
        this.loading = false
      }
    },
    setFkkoRows(fkko) {
      const objectLength = Object.keys(this.rows)

      this.rows[objectLength] = {
        label: 'Принимает',
        value: 'z_accepts',
      }
      this.rows[objectLength + 1] = {
        label: 'Не принимает',
        value: 'z_not_accepts',
      }
      const fields = [
        {
          prop: 'z_accepts',
          value: 'accepts',
        },
        {
          prop: 'z_not_accepts',
          value: 'not_accepts',
        },
      ]

      fields.forEach((el) => {
        this.fields[el.prop] = fkko[el.value]
          .map((item) => {
            return `<span title='${item.name}'>${String(item.code).slice(
              0,
              6
            )}</span>`
          })
          .join(', ')
      })
    },
  },
}
